/**
 * Application Routes
 */
import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PrivateRoute from '@/components/PrivateRoute';
import LoadingScreen from '@/components/LoadingScreen';

// Lazy load pages
const LoginPage = lazy(() => import('@/pages/LoginPage'));
const RegisterPage = lazy(() => import('@/pages/RegisterPage'));
const RegistrationComplete = lazy(() => import('@/pages/RegistrationComplete'));
const ForgotPasswordPage = lazy(() => import('@/pages/ForgotPasswordPage'));
const MainApp = lazy(() => import('@/pages/MainApp'));
const AdminTools = lazy(() => import('@/pages/AdminTools'));
const PaymentSuccess = lazy(() => import('@/pages/PaymentSuccess'));

export const AppRoutes: React.FC = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/ja/register" element={<RegisterPage />} />
        <Route path="/en/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/ja/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/en/forgot-password" element={<ForgotPasswordPage />} />
        <Route
          path="/registration-complete"
          element={
            <PrivateRoute>
              <RegistrationComplete />
            </PrivateRoute>
          }
        />
        <Route
          path="/"
          element={
            <PrivateRoute>
              <MainApp />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <PrivateRoute>
              <AdminTools />
            </PrivateRoute>
          }
        />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;